import {GridOptions, themeQuartz} from 'ag-grid-community';

export const agGridTheme = themeQuartz.withParams({
  wrapperBorder: false,
  backgroundColor: '#ffffff',
  foregroundColor: '#000000',
  headerBackgroundColor: '#ffffff',
  spacing: 8,
  // Use the site's font, not the theme's own
  fontFamily: 'inherit',
  fontSize: 12,
  headerFontSize: 12,
  headerFontWeight: 800,
  oddRowBackgroundColor: '#f8f8f8',
});

export const agGridDefaults: GridOptions = {
  pagination: true,
  domLayout: 'autoHeight',
  defaultColDef: {
    flex: 1,
    minWidth: 100,
    resizable: true,
    filter: true,
    sortable: true,
  },
};
